import RightSidebarContent from './RightSidebarContent';

export default RightSidebarContent;
